// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `button:focus {
  outline: none;
}

.btn {
  /* Display & Box Model */
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  min-width: 16rem;
  margin: 0.3rem;
  /* Text */
  font-weight: 500;
  text-decoration: none;
  /* Other */
  transition: 0.5s;
}

.btn:active path,
.btn:hover path,
path {
  transition: 0.3s;
}

/* size */

.btn-xs {
  /* Display & Box Model */
  border-radius: 2px;
  width: fit-content;
  align-self: center;
  padding-right: 1rem;
  padding-left: 1rem;
  min-height: 3rem;

  /* Text */
  font-size: 1rem;
  line-height: 1.5;
}
.btn-sm {
  /* Display & Box Model */
  padding-right: 1rem;
  padding-left: 1rem;
  min-height: 3rem;
  border-radius: 2px;

  /* Text */
  font-size: 1rem;
  line-height: 1.5;
}

.btn-lg {
  /* Display & Box Model */
  padding-left: 1rem;
  padding-right: 1rem;
  border-radius: 2px;

  /* Text */
  font-size: 1rem;
  min-height: 3rem;
  line-height: 1.5;
  letter-spacing: 0.1px;
}

/* variant */

.btn-light {
  background: white;
  color: var(--text-color-dark);
  font-weight: 600;
  border: var(--text-color-dark);
  box-shadow: 6.9829px 8.72862px 15.7115px rgba(1, 1, 1, 0.25);
  text-decoration: none;
}
.btn-light:hover {
  color: white !important;
  background: var(--secondaryColor);
  border: white;
  font-weight: 400;
}
.btn-light:focus {
  color: white;
  background: var(--secondaryColor);
  border: white;
}

.btn-light:active,
.btn-light:hover {
  color: white;
}

.btn-primary {
  background: var(--blackBg);
  color: white;
  border: white;
  box-shadow: 6.9829px 8.72862px 15.7115px rgba(1, 1, 1, 0.25);
  text-decoration: none;
  font-weight: 600;
}

.btn-primary:hover {
  color: white !important;
  background: var(--secondaryColor);
  border: white;
  font-weight: 400;
}
.btn-primary:focus {
  color: white;
  background: var(--secondaryColor);
  border: white;
}

.language-button {
  border: none;
  background-color: transparent;
  color: var(--secondaryColor);
}
.language-button:hover {
  border: 1px solid var(--secondaryColor);
  color: var(--light-grey);
  padding: 0.5rem;
  border-radius: var(--borderRadius);
}
/* MOBILE STYLES */

@media only screen and (max-width: 650px) {
  .btn {
    min-width: 11rem;
    width: 14rem;
    align-self: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/button.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,qBAAqB;EACrB,UAAU;EACV,gBAAgB;AAClB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA,SAAS;;AAET;EACE,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;;EAEhB,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;;EAElB,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;;EAElB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,YAAY;;AAEZ;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,gBAAgB;EAChB,8BAA8B;EAC9B,4DAA4D;EAC5D,qBAAqB;AACvB;AACA;EACE,uBAAuB;EACvB,iCAAiC;EACjC,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,iCAAiC;EACjC,aAAa;AACf;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,aAAa;EACb,4DAA4D;EAC5D,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,iCAAiC;EACjC,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,iCAAiC;EACjC,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA;EACE,uCAAuC;EACvC,wBAAwB;EACxB,eAAe;EACf,kCAAkC;AACpC;AACA,kBAAkB;;AAElB;EACE;IACE,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;EACpB;AACF","sourcesContent":["button:focus {\n  outline: none;\n}\n\n.btn {\n  /* Display & Box Model */\n  padding-left: 0.25rem;\n  padding-right: 0.25rem;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  min-width: 16rem;\n  margin: 0.3rem;\n  /* Text */\n  font-weight: 500;\n  text-decoration: none;\n  /* Other */\n  transition: 0.5s;\n}\n\n.btn:active path,\n.btn:hover path,\npath {\n  transition: 0.3s;\n}\n\n/* size */\n\n.btn-xs {\n  /* Display & Box Model */\n  border-radius: 2px;\n  width: fit-content;\n  align-self: center;\n  padding-right: 1rem;\n  padding-left: 1rem;\n  min-height: 3rem;\n\n  /* Text */\n  font-size: 1rem;\n  line-height: 1.5;\n}\n.btn-sm {\n  /* Display & Box Model */\n  padding-right: 1rem;\n  padding-left: 1rem;\n  min-height: 3rem;\n  border-radius: 2px;\n\n  /* Text */\n  font-size: 1rem;\n  line-height: 1.5;\n}\n\n.btn-lg {\n  /* Display & Box Model */\n  padding-left: 1rem;\n  padding-right: 1rem;\n  border-radius: 2px;\n\n  /* Text */\n  font-size: 1rem;\n  min-height: 3rem;\n  line-height: 1.5;\n  letter-spacing: 0.1px;\n}\n\n/* variant */\n\n.btn-light {\n  background: white;\n  color: var(--text-color-dark);\n  font-weight: 600;\n  border: var(--text-color-dark);\n  box-shadow: 6.9829px 8.72862px 15.7115px rgba(1, 1, 1, 0.25);\n  text-decoration: none;\n}\n.btn-light:hover {\n  color: white !important;\n  background: var(--secondaryColor);\n  border: white;\n  font-weight: 400;\n}\n.btn-light:focus {\n  color: white;\n  background: var(--secondaryColor);\n  border: white;\n}\n\n.btn-light:active,\n.btn-light:hover {\n  color: white;\n}\n\n.btn-primary {\n  background: var(--blackBg);\n  color: white;\n  border: white;\n  box-shadow: 6.9829px 8.72862px 15.7115px rgba(1, 1, 1, 0.25);\n  text-decoration: none;\n  font-weight: 600;\n}\n\n.btn-primary:hover {\n  color: white !important;\n  background: var(--secondaryColor);\n  border: white;\n  font-weight: 400;\n}\n.btn-primary:focus {\n  color: white;\n  background: var(--secondaryColor);\n  border: white;\n}\n\n.language-button {\n  border: none;\n  background-color: transparent;\n  color: var(--secondaryColor);\n}\n.language-button:hover {\n  border: 1px solid var(--secondaryColor);\n  color: var(--light-grey);\n  padding: 0.5rem;\n  border-radius: var(--borderRadius);\n}\n/* MOBILE STYLES */\n\n@media only screen and (max-width: 650px) {\n  .btn {\n    min-width: 11rem;\n    width: 14rem;\n    align-self: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
